import React from "react";

export default ({ children }) => {
	return (
		<div className="main-layout">
			<div className="content-container">{children}</div>
		</div>
	);
};
